export default {
    computed: {
        isDebugMode: () => process.env.NODE_ENV === 'development',
        isDemoSystem: () => process.env.VUE_APP_ENV === 'demo',
        isGrfSystem: () => process.env.VUE_APP_ENV === 'grf',
        isHeidilandSystem: () => process.env.VUE_APP_ENV === 'heidiland',

        demoMessage() {
            const currentHour = new Date().getHours();
            const resetHour = currentHour + (currentHour % 2 ? 1 : 2);
            const formatHour = `0${resetHour}`.slice(-2);

            return `Demo-System wird zurückgesetzt um ${formatHour}:00 Uhr`;
        },
    },
};
